import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const UserSettingsTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'user:tabNavigation.users',
      route: RoutesEnum.Users,
    },
    {
      label: 'user:tabNavigation.settings',
      route: RoutesEnum.UsersSettings,
    },
  ];
  return <PageTabNavigation pageTabs={pageTabs} />;
};
